module.exports = __webpack_public_path__ + "img/canbadge_hachikaku_58mm.dea8f548.png";